<template>
  <div class="lottery-content">
    <div class="lottery_title">
      <p>
        <span>{{ state.surplusNum }}</span
        >次
      </p>
    </div>

    <p class="activeTime">活动时间：{{ state.strtime }}~{{ state.endtime }}</p>
    <div class="lottery">
      <LotteryList
        ref="lottery1"
        @onend="onend"
        :list="state.lotteryList"
        @onsubmit="request('lottery1')"
      ></LotteryList>
    </div>

    <div class="lotteryInfo">
      <div class="info_left">
        <p class="todayRecharge">当前实付充值金额：{{ state.recharge }}</p>
        <p>每实付充值100元增加1次抽奖次数</p>
      </div>
      <div class="info_right">
        <span>剩余次数</span>
        <span>{{ state.lotteryNumber }}</span>
        <!-- <span>69</span> -->
      </div>
    </div>

    <div class="prizeInfoMation">
      <ul>
        <li v-for="(item, index) in state.lotteryLog" :key="index">
          <p>{{ item.lottery_log_cont }}</p>
          <p>{{ item.lottery_log_time }}</p>
        </li>
      </ul>
    </div>

    <div class="lottery_rule" @click="openRule">
      <img src="../../assets/yz/lotteryImg/lottery_Rule.png" alt="" />
    </div>

    <!-- 规则弹出 -->
    <van-popup v-model:show="state.ruleShow" @close="popupClose">
      <div class="ruleDetail">
        <pre>{{ state.guize }}</pre>
      </div>
      <p @click="closePopup">关闭</p>
      <span>
        <van-checkbox
          v-model="noTips"
          shape="square"
          checked-color="#FFE5B9"
          icon-size="15px"
          @change="tipsChange"
          >下次不再提示</van-checkbox
        >
      </span>
    </van-popup>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { getQueryString } from "../../utils/location";
import { setToken, getToken } from "../../utils/auth";
import { Toast } from "vant";
import { userInfo, startLottery, lotteryInfo } from "@/api/Lottery.js";
import { dateChangeFomat3 } from "../../utils/date";

const state = reactive({
  // 充值金额
  recharge: 0,
  // 抽奖次数
  lotteryNumber: 0,
  ruleShow: false,
  uid: "",
  noTips: false,

  //奖品列表
  lotteryList: [
    {
      index: "0",
    },
    {
      index: "1",
    },
    {
      index: "2",
    },
    {
      index: "3",
    },
    {
      index: "4",
    },
    {
      index: "5",
    },
    {
      index: "6",
    },
    {
      index: "7",
    },
    {
      index: "8",
    },
  ],

  // 中奖记录
  lotteryLog: [],

  token: "",

  // 总抽奖次数
  surplusNum: 5000,

  // 活动时间
  strtime: "",
  endtime: "",

  // 活动规则
  guize: "",
});

const noTips = ref(true);

onMounted(() => {
  if (getQueryString("token") != "undefined") {
    setToken(getQueryString("token"));
    state.token = getQueryString("token");
  } else {
    setToken(route.query.token);
    state.token = route.query.token;
  }
  getLotteryInfo();
  getUseInfo();

  state.noTips = localStorage.getItem("isShowRules");
  if (localStorage.getItem("isShowRules") == "false") {
    state.ruleShow = true;
    state.noTips = false;
  } else {
    state.ruleShow = false;
  }
});

const getLotteryInfo = async () => {
  let res = await lotteryInfo();
  // console.log("抽奖信息-----------", res);
  if (res.data.code == 1) {
    state.strtime = dateChangeFomat3(res.data.data.strtime);
    state.endtime = dateChangeFomat3(res.data.data.endtime);
    state.guize = res.data.data.guize;
  }
};

// 获取用户充值及抽奖信息
const getUseInfo = async () => {
  // console.log('state.token',state.token)
  let res = await userInfo({
    token: state.token,
  });

  console.log("抽奖返回的信息-----------", res.data);

  state.recharge = res.data.data.sum;
  state.lotteryNumber = res.data.data.cjnum;
  state.lotteryList = res.data.data.list;
  state.lotteryLog = res.data.data.lotteryLog;
  state.surplusNum = res.data.data.surplusNum;
};

const lottery1 = ref(null);

var lotteryResult = "";

// 增加一个阻断
var isClick = false;

// 开始抽奖
const request = async (name) => {
  if (isClick) {
    Toast("正在抽奖中，请勿重复点击");
    return;
  }
  isClick = true;
  startLottery({
    token: state.token,
  }).then((res) => {
    if (res.data.code == "1") {
      lotteryResult = res.data.msg;
      setTimeout(() => {
        lottery1.value.go(res.data.data.pnum);
      }, 500);
    } else {
      Toast(res.data.msg);
      isClick = false;
    }
  });
};
// 抽奖动画结束
const onend = (data) => {
  getUseInfo();
  Toast(lotteryResult);
  isClick = false;
};

const openRule = () => {
  state.ruleShow = true;
};

const closePopup = () => {
  state.ruleShow = false;
};

const popupClose = () => {
  localStorage.setItem("isShowRules", noTips.value);
};

const tipsChange = () => {
  localStorage.setItem("isShowRules", noTips.value);
};
</script>

<style scoped>
/* 在需要的情况下添加样式 */

:deep(.prize__item__mask) {
  border: 6px solid #db00ff;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0);
}

.lottery-content {
  width: 100%;
  height: 1900px;
  background: url(../../assets/yz/lotteryImg/lottery_bg.png) no-repeat;
  background-size: 100% 100%;
  padding-top: 18px;
  padding-left: 80px;
}
.activeTime {
  margin-left: 120px;
  margin-top: 36px;
  font-size: 20px;
  color: #fff;
}
:deep(.lottery__list) {
  justify-content: space-around;
}
:deep(.lattice__lottery__box) {
  width: 586px;
  border: 0;
  margin-top: 46px;
  padding: 20px;
  margin-left: 2px;
}
:deep(.prize__item:nth-of-type(1)) {
  background: url(../../assets/yz/lotteryImg/item_bg_1.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item:nth-of-type(2)) {
  background: url(../../assets/yz/lotteryImg/item_bg_2.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item:nth-of-type(3)) {
  background: url(../../assets/yz/lotteryImg/item_bg_3.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item:nth-of-type(4)) {
  background: url(../../assets/yz/lotteryImg/item_bg_4.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item:nth-of-type(5)) {
  background: url(../../assets/yz/lotteryImg/item_bg_5.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item:nth-of-type(6)) {
  background: url(../../assets/yz/lotteryImg/item_bg_6.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item:nth-of-type(7)) {
  background: url(../../assets/yz/lotteryImg/item_bg_7.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item:nth-of-type(8)) {
  background: url(../../assets/yz/lotteryImg/item_bg_8.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item:nth-of-type(9)) {
  background: url(../../assets/yz/lotteryImg/item_bg_9.png) no-repeat;
  background-size: 100% 100%;
}
:deep(.prize__item) {
  width: 165px;
  height: 165px;
  border: 0;
}

/* 抽奖头部 */
.lottery_title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 248px;
  position: relative;
}
.lottery_title p {
  position: absolute;
  left: 385px;
  bottom: -15px;
  font-size: 30px;
  font-weight: 800;
  color: #d96779;
}
.lottery_title p span {
  color: #ffb81f;
  margin-right: 8px;
}
.lottery_title img {
  width: 100%;
  height: 248px;
  margin-left: -100px;
}

/* 今日实付 */
.lotteryInfo {
  margin-top: 106px;
  font-size: 24px;
  color: #000;
  display: flex;
  color: #d46211;
  font-weight: 600;
  line-height: 28px;
}
.lotteryInfo .info_left {
  width: 476px;
}
.lotteryInfo .info_right {
  display: flex;
  align-items: center;
}
.lotteryInfo .info_right span {
  width: 48px;
}
.lotteryInfo .info_right span:nth-of-type(2) {
  min-width: 48px;
  height: 48px;
  background-color: #fdfbf5;
  border-radius: 8px;
  margin-left: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 抽奖按钮 */
:deep(.lattice__lottery__btn) {
  width: 630px;
  height: 115px;
  opacity: 1;
  position: absolute;
  background-color: #a10e26;
  opacity: 0;
  bottom: -285px;
  border-radius: 20px;
}

/* 中奖信息 */
.prizeInfoMation {
  height: 400px;
  width: 656px;
  margin-left: -36px;
  margin-top: 300px;
  box-sizing: border-box;
  overflow: auto;
}
.prizeInfoMation ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 12px 24px;
  border-radius: 20px;
  margin-bottom: 16px;
}
.lottery_rule {
  position: fixed;
  top: 180px;
  right: 0;
}
.lottery_rule img {
  width: 54px;
  height: 104px;
}
.ruleDetail {
  width: 575px;
  height: 872px;
  background-image: url(../../assets/yz/lotteryImg/lottery_Rule_detail.png);
  background-size: 100% 100%;
  padding: 46px;
  padding-top: 124px;
  font-size: 28px;
  color: #a10e26;
}
.ruleDetail pre {
  text-wrap: wrap;
}
:deep(.van-popup) {
  background-color: rgba(0, 0, 0, 0);
}
:deep(.van-popup) p {
  margin: 0 auto;
  width: 316px;
  height: 82px;
  font-size: 44px;
  color: #a10e26;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(249, 227, 178);
  border-radius: 198px;
  margin-top: 30px;
}
:deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.5);
}
:deep(.van-checkbox) {
  justify-content: center;
  font-size: 30px;
  align-items: center;
  margin-top: 15px;
}
:deep(.van-checkbox__label) {
  color: #fff;
}
:deep(.lottery) {
  position: relative;
}
</style>
